import { useTranslation } from 'react-i18next';

const BusinessItem = ({ title, description }) => {
  return (
    <div className="solutions__business-item">
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

export default function BusinessModels() {
  const { t } = useTranslation();

  return (
    <section className="solutions__business">
      <BusinessItem
        title={t('solutions.b2c.title')}
        description={t('solutions.b2c.description')}
      />
      <BusinessItem
        title={t('solutions.b2b.title')}
        description={t('solutions.b2b.description')}
      />
    </section>
  );
}
